// Default timer values (in seconds)
export const DEFAULT_EXPIRES_IN = 300
export const DEFAULT_CAN_RESEND_AFTER = 60

// Email validation regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Error messages
export const ERROR_MESSAGES = {
  EMPTY_EMAIL: 'Please enter your email address',
  INVALID_EMAIL: 'Please enter a valid email address',
  SEND_FAILED: 'Failed to send OTP. Please try again.'
}

// Success messages
export const SUCCESS_MESSAGES = {
  OTP_SENT: 'OTP sent successfully to your email'
}
